
  import {prepareImageUrl} from '@/helper/ImageHelper';

  export default {
    name: 'SectionMediumHero',
    components: {
      RichText: () => import('@/components/elements/RichText'),
    },
    props: {
      section: {
        type: Object,
        required: false,
        default: () => {},
      },
    },
    serverCacheKey(props) {
      return 'section-medium-hero-' + props.section.id;
    },
    data() {
      return {
        imageUrl: require(process.env.NUXT_ENV_FALLBACK_MEDIUM_HERO_IMAGE),
        sublineWithLineBreaks: '',
      };
    },
    created() {
      const imageUrl = this.section.image
        ? (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) &&
          this.section.image.formats.medium &&
          this.section.image.formats.medium.url
          ? this.section.image.formats.medium.url
          : this.section.image.url
        : false;

      if (imageUrl) {
        this.imageUrl = prepareImageUrl(imageUrl);
      }
      this.sublineWithLineBreaks = this.section.subline
        ? this.section.subline.replace(/\n/g, '<br>')
        : '';
    },
  };
